import type { UrgencyLevel } from "../hooks/usePhaseCountdown";

/**
 * Soft “cop light” edge wash when the phase clock is running low.
 * Pointer-events none — purely atmospheric, not a modal.
 */
export function UrgencyLights({ urgency }: { urgency: UrgencyLevel }) {
  if (urgency === "none") return null;

  const critical = urgency === "critical";

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[60] overflow-hidden"
      aria-hidden
    >
      {/* Left wash — red */}
      <div
        className={`urgency-bar urgency-bar-left ${
          critical ? "urgency-bar-critical" : "urgency-bar-warn"
        }`}
      />
      {/* Right wash — blue */}
      <div
        className={`urgency-bar urgency-bar-right ${
          critical ? "urgency-bar-critical" : "urgency-bar-warn"
        }`}
      />
      {/* Top/bottom subtle pulse on critical only */}
      {critical && (
        <>
          <div className="urgency-bar urgency-bar-top urgency-bar-critical" />
          <div className="urgency-bar urgency-bar-bottom urgency-bar-critical" />
        </>
      )}
    </div>
  );
}
